'use client';

import { WithdrawPlayerForm } from '@/components/forms/modals/WitdhdrawPlayerForm';
import { ModalWrapper } from '@/components/organisms';
import { EditRegistrationData } from '@/entities/EditOrganizationModalSchemeData';
import { useWithdrawPlayerFromLeagueMutation } from '@/hooks/league/useWithdrawPlayerFromLeagueMutation';
import { useOrganizationStore } from '@/store/organization-store';

interface WithdrawPlayerModalProps {
	onClose: () => void;
}

export const WithdrawPlayerModal = ({ onClose }: WithdrawPlayerModalProps) => {
	const organizationStore = useOrganizationStore();

	const { mutate: withdrawPlayer, isPending } = useWithdrawPlayerFromLeagueMutation();

	const handleFormSubmit = (_data: EditRegistrationData) => {
		withdrawPlayer({
			organizationUuid: organizationStore.organizationUuid,
			teamLeagueUuid: organizationStore.teamLeagueUuid,
			comments: _data.comment
		});

		onClose();
	};

	return (
		<ModalWrapper className="!max-w-[475px] !gap-0" title="Withdraw from league" onClose={onClose} closeOnOutsideClick={true}>
			<p className="font-medium py-4">
				By clicking Confirm below, you understand that you are withdrawing your registration from this league. You will be subject to the
				cancellation and refund policy set by the league.
			</p>
			<p className="font-medium">Someone from the league will review this and contact you shortly.</p>
			<WithdrawPlayerForm onSubmit={handleFormSubmit} onClose={onClose} isSubmitting={isPending} />
		</ModalWrapper>
	);
};
